import React, {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import './portfolio.css'

const Portfolio = () => {
    const [portfolio, setPortfolio] = useState([])
    const [error, setError] = useState()
    const [popupData, setPopupData] = useState()
    const navigate = useNavigate();

    const getAllPortfolio = async() =>{
        try{
            const resp = await fetch("/data/db.json")
            if(!resp.ok){
                throw new Error(`Error Encounter: ${resp.error}`)

            }
            const data = await resp.json();
            setPortfolio(data.ProjectsData);
        }catch(err){
            setError(err.message)
        }
    }

    useEffect(()=>{
        getAllPortfolio();
    })

    const openPopup = (project) => {
        setPopupData(project);
    };

    const closePopup = () => {
        setPopupData(null);
    };

    const handleDownload = () =>{
        window.open(popupData.link, '_blank');
    }

    // const handleNewWindow = (iframeLink) =>{
    //     window.open(`/iframe/${encodeURIComponent(iframeLink)}`, '_blank');
    // }

    const openIframeComponent = (iframeLink) => {
        navigate(`/iframe/${encodeURIComponent(iframeLink)}`, '_blank');
    };


    return (
        <div className="Portfolio">
            <div className="subPortfolio">
                {portfolio.map((project) => (
                    <div className="card" key={project.id}>
                        <div
                            className="img"
                            onClick={() => openPopup(project)}
                            // onClick={() => openIframeComponent(project.iframeLink)}
                            title={project.title}
                        >
                            <img src={project.image} alt={project.title} />
                        </div>
                    </div>
                ))}
            </div>

            {popupData && (
                <div className="Portfoliopopup">
                    <div className="PortfoliopopupContent">
                        <button className="ProjectcloseButton" onClick={closePopup}>
                            &times;
                        </button>
                        <h2>{popupData.title}</h2>
                        <iframe
                            src={popupData.iframeLink || popupData.link}
                            title={popupData.title}
                            frameBorder="0"
                            allowFullScreen
                        ></iframe>
                        <button onClick={handleDownload} className='DownloadBtn'>Download</button>
                        <button onClick={openIframeComponent} className='DownloadBtn'>New Window</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Portfolio